import React from "react";
import { useTranslation } from "react-i18next";

import {
  PRIMARIES,
  ACCESSORIES,
  OLYMPICS,
  STRONGMAN,
} from "../../../../utils/exercise-catalog";

const PRIMARY_VALUE_TO_KEY = { bench: "benchPress" };

const getCategoryLabelKey = (value, isAccessory) => {
  if (isAccessory) {
    return value.toLowerCase();
  }
  return PRIMARY_VALUE_TO_KEY[value] || value;
};

const MobileCatalogSelectors = ({
  onSelectorClick,
  filter,
  selectedExercises,
}) => {
  const { t } = useTranslation("coaching-portal");
  const cat = (key) => t(`exerciseLibraryCatalog.categories.${key}`);

  const combinedItems = [
    ...ACCESSORIES.map((value) => {
      let count = 0;
      selectedExercises.assistant.forEach((ex) => {
        if (ex.primaryMuscleGroup === value) count++;
        if (value === "Other" && !ex.primaryMuscleGroup) count++;
      });
      return {
        type: "accessory",
        value,
        count,
      };
    }),
    ...PRIMARIES.map(({ value }) => ({
      type: "primary",
      value,
      count: selectedExercises[value].length,
    })),
    ...OLYMPICS.map(({ value }) => ({
      type: "olympic",
      value,
      count: selectedExercises[value].length,
    })),
    ...STRONGMAN.map(({ value }) => ({
      type: "strongman",
      value,
      count: selectedExercises[value].length,
    })),
  ];

  return (
    <ul className="mobile-catalog-selection">
      {combinedItems.map(({ type, value, count }) => {
        const isAccessory = type === "accessory";
        const label = cat(getCategoryLabelKey(value, isAccessory));
        return (
          <li
            key={`${type}-${value}`}
            className={`category-item${filter === value ? " active" : ""}`}
          >
            <button
              data-button-type={filter === value ? "primary" : "text-white"}
              onClick={() => onSelectorClick(value)}
            >
              {label}
              {count ? <span>({count})</span> : null}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default MobileCatalogSelectors;
